import { ApiError } from '@teko/api';
import { t } from './i18n.es.js';

const ErrorMessageMapping = new Map([
    [400400, 'Khuyến mãi tặng voucher đã hết ngân sách'],
    [400401, 'Giỏ hàng có khuyến mãi hết ngân sách'],
    [400402, 'Mã giảm giá đã được sử dụng hoặc quá số lần sử dụng'],
    [400403, 'Giỏ hàng có sản phẩm đã được cập nhật lại giá'],
    [400404, 'Bạn đã sử dụng mã giảm giá vượt quá số lần cho phép'],
    [400405, 'Giỏ hàng chứa khuyến mãi đã bị vô hiệu'],
    [400406, 'Giỏ hàng chứa sản phẩm không được phép áp dụng khuyến mãi'],
    [400407, 'Bạn không đủ điều kiện để hưởng khuyến mãi'],
    [400408, 'Mã giảm giá quá hạn sử dụng'],
    [400409, 'Giỏ hàng chứa flash sale đã bị vô hiệu'],
    [400410, 'Giỏ hàng chứa flash sale đã hết số lượng khuyến mãi'],
    [400411, 'Giỏ hàng chứa một số sản phẩm hết hàng hoặc không đủ số lượng'],
    [400412, 'Không thể giữ tồn do đơn hàng đã được giữ tồn thành công trước đó'],
    [
        400413,
        'Đơn hàng đã thanh toán thành công nên không thể thực hiện cập nhật đơn hàng được nữa. Vui lòng kiểm tra lại đơn hàng nếu vẫn muốn tiếp tục cập nhật!',
    ],
    [
        400414,
        'Đơn hàng đã bị hủy trước đó nên không thể thực hiện cập nhật đơn hàng được nữa. Vui lòng kiểm tra lại đơn hàng nếu vẫn muốn tiếp tục cập nhật!',
    ],
    [400501, 'Mã đã được sử dụng hoặc quá số lần sử dụng'],
    [400502, 'Số lượt sử dụng mã giảm giá đã hết'],
    [400503, 'Mã không hợp lệ'],
    [400504, 'Giá trị đơn hàng không thỏa mãn điều kiện áp dụng mã'],
    [400505, 'Sản phẩm trong giỏ hàng không được áp dụng mã'],
    [400506, 'Mã giảm giá không áp dụng cho tài khoản của bạn'],
    [400507, 'Mã không hợp lệ'],
    [400508, 'Ngân sách sử dụng mã đã hết'],
    [400509, 'Bạn đã sử dụng mã giảm giá vượt quá số lần cho phép'],
    [400510, 'Vui lòng đăng nhập để sử dụng mã'],
    [
        400511,
        'Số tiền giảm của mã giảm giá đang lớn hơn giá trị đơn hàng của bạn',
    ],
    [400512, 'Mã giảm giá không hợp lệ, vui lòng thử lại'],
    [400513, 'Mã giảm giá không tồn tại hoặc đã bị vô hiệu'],
    [
        400204,
        'Mã giảm giá này không thể áp dụng cùng với giảm giá combo sản phẩm đang có trong giỏ hàng. Bạn có chắc chắn muốn xóa combo sản phẩm để áp dụng mã giảm giá?',
    ],
    [
        400205,
        'Khuyến mãi này không thể áp dụng cùng với giảm giá combo sản phẩm đang có trong giỏ hàng. Bạn có chắc chắn muốn xóa combo sản phẩm để nhận khuyến mại này?',
    ],
    [400201, 'Không thể áp dụng thêm Mã giảm giá/Phiếu mua hàng'],
    [400922, 'Vui lòng chọn thời gian nhận hàng lớn hơn thời gian hiện tại!'],
    [400011, 'Mã giảm giá không tồn tại hoặc đã bị vô hiệu'],
    [
        400258,
        'Không có kho hàng nào được cấu hình cho việc bán hàng tại cửa hàng của bạn. Vui lòng kiểm tra lại với cửa hàng trưởng và chắc chắn là có ít nhất 1 kho được cấu hình cho cửa hàng của bạn.',
    ],
    [
        400260,
        'Nền tảng bán hàng không cho phép thanh toán trả chậm. Vui lòng kiểm tra lại!',
    ],
    [500112, 'Lỗi không lấy được thông tin kho xuất. Vui lòng thử lại sau!'],
]);
const getError = (resp) => {
    const tKey = ErrorMessageMapping.get(resp.statusCode) || 'DEFAULT_ERROR';
    const message = t(tKey);
    return new ApiError(message, resp.statusCode, resp);
};

export { ErrorMessageMapping, getError };
